<template>
    <section class="faq" id="faq">
        <div class="container">
            <div class="faq-list">
                <details v-for="faqItem in require('../../data/faq.js')" :key="faqItem.id"
                    :open="currentFaqItemId === faqItem.id" >
                    <summary @click="toggleFaqItem($event, faqItem.id)" tabindex="0">
                        {{ faqItem.question }}
                    </summary>
                    <div :class="{'with-image': faqItem.hasOwnProperty('image')}">
                        <p>
                            {{ faqItem.answer }}
                        </p>
                        <img v-if="faqItem.hasOwnProperty('image')" :src="faqItem.image" />
                    </div>
                </details>
            </div>
        </div>
    </section>
</template>

<script>
    import {
        TimelineMax,
        TweenMax
    } from 'gsap'

    export default {
        data: () => ({
            currentFaqItemId: null
        }),
        methods: {
            toggleFaqItem(e, id) {
                e.preventDefault()
                this.currentFaqItemId = this.currentFaqItemId === id ? null : id
            }
        },
        mounted() {
            const timeline = new TimelineMax()

            Array.from(document.querySelectorAll('.faq-list details')).forEach(el => {
                timeline.add(TweenMax.to(el, .01, {
                    transform: 'translate(0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }))
            })

            const toggleDetailsScene = this.$scrollmagic.scene({
                triggerElement: '#faq',
                triggerHook: 2,
                duration: 500
            }).setTween(timeline)

            this.$scrollmagic.addScene(toggleDetailsScene)
        }
    }
</script>

<style lang="scss" scoped>
@import '../../vars';
    .faq {
        margin-top: 10vh;

        details {
            opacity: 0;
            visibility: hidden;
            transform: translate(0, 1em);
            margin: 1em 0;
            transition: .2s transform;
        

            summary {
               
                cursor: pointer;
                color: rgba(0, 0, 0, 0.5);
                font-size: 1.2em;
                    &:focus{
                    outline: 2px solid rgba(0, 0, 0, 0.2);
                }
            }

            p {
                line-height: 1.5em;
                font-size: 1.2em;
                color: rgba(0, 0, 0, 0.7);
                margin-left: 2em;
                border-left: 3px solid rgba(0, 0, 0, 0.2);
                padding-left: 1em;
                          @media(max-width: 580px){
            margin-left:0;
        }
            }

            &[open] summary {
                color: black;
            }

            .with-image {
                display: flex;

                p {
                    flex: 1;
                    padding-right: 4em;
                }

                img {
                    max-height: 300px;
                }
            }

        }

    }

    @keyframes pain-animation {
        0% {
            transform: scale(0.2);
        }

        50% {
            transform: scale(1);
        }

        100% {
            transform: scale(0.2);
        }
    }
</style>
